export default "/institutions/vr.svg";